import { faArrowDownLeft } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatNumber } from "../../utils/helpers";
import { getSystem } from "../../utils/api_mutex";
import { Space } from "react-zoomable-ui";
import { styled } from "styled-components";
import { transition } from "../../styles/mixins";
import { useState } from "react";
import Flow from "../common/Flow";
import Table from "../common/Table";
import Typography from "../common/Typography";
import WaypointList from "./WaypointList";
import Window from "../common/Window";
import { getBounds } from "../../utils/calculations";

const Star = styled.div`
  cursor: pointer;
  left: ${props => props.$x}px;
  position: absolute;
  top: ${props => props.$y}px;
  translate: -50% -50%;
  width: var(--space-6);
  z-index: 0;

  &::after,
  &::before {
    ${transition('opacity, scale')}
    aspect-ratio: 1;
    border-radius: 100%;
    content: '';
    pointer-events: none;
    position: absolute;
    z-index: -1;
  }

  &::before {
    background-color: var(--color-theme-secondary-500);
    border: var(--border-width) var(--border-style) var(--color-theme-secondary-400);
    inset: calc(var(--space-12) * -1);
    opacity: ${(props) => props.$current ? '1' : '0'};
  }

  &::after {
    background-color: var(--color-theme-accent-500);
    border: var(--border-width) var(--border-style) var(--color-theme-accent-400);
    opacity: ${(props) => props.$selected ? '1' : '0'};
    scale: ${(props) => props.$selected ? '1' : '0'};
    inset: calc(var(--space-4) * -1);
  }

  img {
    height: auto;
    max-width: 100%;
    vertical-align: middle;
  }
`;

const StarDetail = styled(Window)`
  ${transition('opacity, scale')}
  height: calc(100% - var(--space-12));
  opacity: ${(props) => props.$isOpen ? '1' : '0'};
  position: absolute;
  right: var(--space-6);
  scale: ${props => props.$isOpen ? '1' : '0.75'};
  top: var(--space-6);
  transform-origin: right bottom;
  width: 288px;
  z-index: 1;
  overflow-y: scroll;
`;

const Location = styled.div`
  align-items: center;
  background-color: red;
  background-color: var(--color-theme-secondary-500);
  border: var(--border-width) var(--border-style) var(--color-theme-secondary-400);
  display: flex;
  gap: var(--space-1);
  padding: var(--space-1);
  position: absolute;
  right: 0;
  translate: 100% -100%;
  width: max-content;
`;

function Systems({ store }) {
  const [system, setSystem] = useState(false);
  const systems = store.state.systems;
  const bounds = getBounds(systems);
  const currentSystem = store.state.system;
  const ship = store.getSelectedShip();

  const clickHandle = (systemSymbol) => {
    const findShip = systems && systems.find(s => s.symbol == systemSymbol)

    getSystem('main', store.state.token, systemSymbol)
      .then((res) => {
        if (res.error) {
          alert('system error');
        } else {
          setSystem({...res.data, distance: findShip.distance});
        }
      })
  }

  return (
    <>
      <StarDetail $isOpen={system} $padding>
        <Flow $space={3}>
          <Typography as="h1" fontSize="xl">{system && system.symbol}</Typography>
          <Table>
            <tbody>
              <tr>
                <th>Sector</th>
                <td>{system && system.sectorSymbol}</td>
              </tr>
              <tr>
                <th>Distance</th>
                <td>{system && formatNumber(system.distance)} lightyear</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{system && system.type}</td>
              </tr>
            </tbody>
          </Table>
          {system && <WaypointList waypoints={system.waypoints} />}
        </Flow>
      </StarDetail>
      {systems.length > 0 &&
        <Space
          onCreate={(viewPort) => {
            viewPort.setBounds({ zoom: [0.1, 2.5] })
            viewPort.camera.centerFitAreaIntoView({
              height: bounds.maxy - bounds.miny,
              left: bounds.minx,
              top: bounds.miny,
              width: bounds.maxx - bounds.minx,
            })
          }}
        >
          <Star $current $x={currentSystem.x} $y={currentSystem.y} onClick={() => store.setModal('')}>
            <Location>
              <FontAwesomeIcon icon={faArrowDownLeft} /> {ship && ship.symbol}
            </Location>
            <img src={`../images/stars/${currentSystem.type}.png`} alt={currentSystem.type} />            
          </Star>
          {systems.map((s, idx) => (
            <Star $selected={system && system.symbol == s.symbol} key={idx} $x={s.x} $y={s.y} onClick={() => clickHandle(s.symbol)}>
              <img src={`../images/stars/${s.type}.png`} alt={s.type} />
            </Star>
          ))}
        </Space>
      }
    </>
  )
}

export default Systems;
